import { firestore } from '../firebase'
import { set as setCookie } from 'vue-cookies'
import store from '../../store'

const affiliate = {
  code: null,

  hasCode () {
    return this.code !== undefined
  },

  async isValid () {
    const affiliateDoc = await firestore
      .collection('affiliates')
      .doc(this.code)
      .get()

    if (!affiliateDoc.exists) return false

    return affiliateDoc.data().active === true
  },

  create () {
    this.createCookie()
    this.createLink()
  },

  createCookie () {
    const { code } = this

    setCookie('manycontent_affiliate', code, { expires: 7, domain: '.manycontent.com' })
    setCookie('manycontent_affiliate', code, { expires: 7, domain: 'localhost' })
  },

  createLink () {
    store.commit('createAffiliateLinks', this.code)
  }
}

export default affiliate
